// File generated from our OpenAPI spec
export const ApiVersion = '2026-01-28.clover';
export const ApiMajorVersion = 'clover';
